module.exports = __webpack_public_path__ + "static/media/contact_marker_map.0d60921c.png";